import script from "./EvalConfigPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./EvalConfigPanel.vue?vue&type=script&setup=true&lang=js"

import "./EvalConfigPanel.vue?vue&type=style&index=0&id=6615ffdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6615ffdc"]])

export default __exports__